// React
import React from 'react';

// components
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { ADGMPanel } from 'aurora-components';
import Grid from '@material-ui/core/Grid';

// utils
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

// Redux
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

/**
  A reuseable component with updated design look that can be used anywhere in the application 
  which takes the following params as props
 * @param { object } data - Object of details
 * @param { string } title - used to define the title for panel
 * @param { arrayOfObjects } labelAndValues - define indetail in the component  
 * @param { number } adgmItemDetialsPerRow - application details   
 * @param { bool } withoutPanel - it will just render the fields in the grid  
 * @returns { node } - return a structured data having Details as per labelAndValues
*/

const ReviewADGMPanelDetails = ({
  classes,
  data,
  title,
  labelAndValues,
  adgmItemDetialsPerRow,
  withoutPanel,
  isAccordion,
}) => {
  const { lang } = useSelector(
    createSelector(
      state => state.language,
      language => ({
        lang: language.locale,
      }),
    ),
  );

  const isAr = lang === 'ar';

  const gridData = () => {
    return (
      !isEmpty(data) && (
        <Grid container className={classes.gridContainer} spacing={3}>
          {labelAndValues.map((item, index) => {
            return (
              <Grid
                item
                key={`detail_${index + 1}`}
                xs={12}
                sm={6}
                md={item.colSpace ?? 12 / adgmItemDetialsPerRow}
                className={classes.itemGrid}
              >
                {item.customRender ? (
                  item.customRender(data, isAr)
                ) : (
                  <ADGMItemDetails
                    label={item.label}
                    value={
                      isAr && item.valuePropertyAr
                        ? data[item.valuePropertyAr]
                        : keyEmptyCheck(data[item.valueProperty])
                    }
                  />
                )}
              </Grid>
            );
          })}
        </Grid>
      )
    );
  };

  return (
    <>
      {withoutPanel ? (
        gridData()
      ) : (
        <ADGMPanel title={title} isAccordion={isAccordion} classes={{ titleHead: classes.titleHead }}>
          <div className={classes.detailsWrapper}>{gridData()}</div>
        </ADGMPanel>
      )}
    </>
  );
};

ReviewADGMPanelDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isAccordion: PropTypes.bool,
  labelAndValues: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      valueProperty: PropTypes.string,
      valuePropertyAr: PropTypes.string,
      customRender: PropTypes.func,
      colSpace: PropTypes.number,
    }),
  ).isRequired,
  adgmItemDetialsPerRow: PropTypes.number,
  withoutPanel: PropTypes.bool,
};

ReviewADGMPanelDetails.defaultProps = {
  adgmItemDetialsPerRow: 3,
  withoutPanel: false,
  isAccordion: false,
};

export default withStyles(styles)(ReviewADGMPanelDetails);
